import styled from 'styled-components';
import { FLINT, CALYPSO_LIGHT } from 'HubStyleTokens/colors';
export const StyledFolderNavItemWrapper = styled.div.withConfig({
  displayName: "styled__StyledFolderNavItemWrapper",
  componentId: "sc-98i97z-0"
})(["background:", ";cursor:pointer;display:flex;line-height:16px;padding:8px;position:relative;z-index:1000;border-radius:3px;"], props => props.isSelected ? CALYPSO_LIGHT : undefined);
export const StyledCountWrapper = styled.span.withConfig({
  displayName: "styled__StyledCountWrapper",
  componentId: "sc-98i97z-1"
})(["color:", ";margin-left:8px;"], FLINT);